<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    text: CONSTS.SUBMIT,
    disable: reconcileForm.pristine || reconcileForm.invalid,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  [leftButton]="{
    text: CONSTS.DOWNLOAD_CSV,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="onSubmit()"
  (emitLeftClick)="downloadCSV()"
>
  <div class="table">
    <!-- Table header -->
    <div class="table-header">
      <ion-row>
        <ion-col size="1">{{ COLUMNTEXT.STOP_DATE }}</ion-col>
        <ion-col size="1">{{ COLUMNTEXT.LOOP }}</ion-col>
        <ion-col size="2">{{ COLUMNTEXT.TRACKING_NUMBER }}</ion-col>
        <ion-col size="1">{{ COLUMNTEXT.SHIPPER }}</ion-col>
        <ion-col size="1">{{ COLUMNTEXT.PAY_AMOUNT }}</ion-col>
        <ion-col size="1">{{ COLUMNTEXT.PAY_TYPE }} </ion-col>
        <ion-col size="1">{{ COLUMNTEXT.STOP_TYPE }}</ion-col>
        <ion-col size="1">{{ COLUMNTEXT.TURN_IN }}</ion-col>
        <ion-col size="1">{{ COLUMNTEXT.AMOUNT }}</ion-col>
        <ion-col size="2" class="ion-padding-start">
          {{ COLUMNTEXT.COMMENTS }}
        </ion-col>
      </ion-row>
    </div>

    <!-- Table body -->
    <div class="table-body">
      <form [formGroup]="reconcileForm" onSubmit="onSubmit()">
        @for (item of controls; track item; let i = $index) {
          <div formArrayName="data">
            <div [formGroupName]="i">
              <ion-row class="reconcile-rows">
                <!-- Stop Date -->
                <ion-col size="1">
                  {{ item.get("stopDate")?.value }}
                </ion-col>
                <!-- Loop -->
                <ion-col size="1">
                  {{ item.get("loop")?.value }}
                </ion-col>
                <!-- Tracking Number -->
                <ion-col size="2">
                  {{ item.get("trackingNo")?.value }}
                </ion-col>
                <!-- Shipper -->
                <ion-col size="1">
                  {{ item.get("shipper")?.value }}
                </ion-col>
                <!-- Pay Amount -->
                <ion-col size="1">
                  {{ item.get("pmntAmount")?.value }}
                </ion-col>
                <!-- Pay Type -->
                <ion-col size="1">
                  {{ item.get("pmntType")?.value }}
                </ion-col>
                <!-- Stop Type -->
                <ion-col size="1">
                  {{ item.get("stopType")?.value }}
                </ion-col>
                <!-- Turn In -->
                <ion-col size="1">
                  <ion-checkbox
                    ngDefaultControl
                    formControlName="turnIn"
                    [disabled]="item.disabled"
                    (ionChange)="updateCheckbox(i)"
                  ></ion-checkbox>
                </ion-col>
                <!-- Turn In Amount-->
                <ion-col size="1">
                  <ion-input
                    ngDefaultControl
                    [attr.name]="'codTurninAmount'"
                    class="form-control"
                    formControlName="codTurninAmount"
                    [ngClass]="{ 'required-amount-input': isInvalid(i) }"
                    [maxlength]="13"
                    (keypress)="
                      commonUtils.preventSpecialCharacters(
                        $event,
                        SpecialCharacters.SPECIAL_WITH_PERIOD
                      )
                    "
                    (ionChange)="updateValidity(i, 'codTurninAmount')"
                  >
                  </ion-input>
                  @if (isInvalid(i)) {
                    <span class="required-amount">{{ CONSTS.REQUIRED }}</span>
                  }
                </ion-col>
                <!-- Turn In Comments-->
                <ion-col size="2" class="ion-padding-start">
                  <ion-input
                    ngDefaultControl
                    [attr.name]="'codTurninComments'"
                    class="form-control"
                    formControlName="codTurninComments"
                    [disabled]="!item.get('turnIn')?.value"
                    [maxlength]="45"
                    (keypress)="
                      commonUtils.preventSpecialCharacters(
                        $event,
                        SpecialCharacters.ALPHABET_NUMBER
                      )
                    "
                    (ionChange)="updateValidity(i, 'codTurninComments')"
                  />
                </ion-col>
              </ion-row>
            </div>
          </div>
        }
      </form>
    </div>
  </div>
</app-modal-frame>
